'use strict';

module.exports = require('./identifiers.data.json');
